import { Card, Container, Icon } from 'components'
import { ObjectStrings } from 'interfaces'
import { BarChart, LocalShipping, Settings } from '@mui/icons-material'

interface IChangelogProps {
  styles: ObjectStrings
  companyProfile: any
}

const MarketingChangelog = (props: IChangelogProps) => {
  const { styles, companyProfile } = props

  return (
    <Container className={styles.marketingContainer}>
      <Container className={styles.transmittingContainer}></Container>
      <Container>
        <Card>
          {companyProfile?.favicon ? (
            <Icon
              type="images"
              url={companyProfile?.favicon}
              boxClassName="fullLogo"
              size={80}
            />
          ) : (
            <Icon name="icon_logo" size={80} />
          )}
          <Container
            sx={{ padding: '1rem' }}
          >
            <Container sx={{ textAlign: 'center', fontFamily: 'Inter-Medium', color: '#666666' }}>
              <h2>Fleet Insurance Intelligence, Simplified</h2>
              <h3><small>Powered by TruckerCloud</small></h3>
            </Container>
            <Container>
              <Container sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', alignItems: 'flex-start', maxWidth: '500px', marginLeft: '3rem', marginTop: '1rem', marginBottom: '1rem' }}>
                <Container sx={{ display: 'flex', gap: '1rem' }}>
                  <BarChart />
                  <span style={{ fontFamily: 'Inter-Regular' }}>Actionable telematics insights in minutes</span>
                </Container>
                <Container sx={{ display: 'flex', gap: '1rem' }}>
                  <Settings />
                  <span style={{ fontFamily: 'Inter-Regular' }}>Works with 100+ ELD & camera providers</span>
                </Container>
                <Container sx={{ display: 'flex', gap: '1rem' }}>
                  <LocalShipping />
                  <span style={{ fontFamily: 'Inter-Regular' }}>Built for commercial-auto underwriting teams and their insureds</span>
                </Container>
              </Container>
              <Container sx={{ marginTop: '2rem', textAlign: 'center' }}>
                <span style={{ fontFamily: 'Inter-Regular' }}>
                  Questions? Email us at <a href="mailto:support@truckercloud.com" style={{ color: '#52a5ea', textDecoration: 'none' }}>support@truckercloud.com</a>
                </span>
              </Container>
            </Container>
          </Container>
        </Card>
      </Container>
    </Container>
  )
}

export default MarketingChangelog
